/* broat Manufaktur – theme.js (ohne Abhängigkeiten) */
(() => {
  'use strict';
  const T = window.theme || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const debounce = (fn, ms = 300) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); }; };

  /* ---------- Toast ---------- */
  let toastTimer;
  function toast(msg) {
    const el = $('[data-toast]');
    if (!el || !msg) return;
    el.textContent = msg; el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { el.hidden = true; }, 3200);
  }

  /* ---------- Overlays (Drawer, Menü, Suche, Filter) ---------- */
  let lastFocus = null;
  function openOverlay(el) {
    if (!el) return;
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    const f = el.querySelector('[data-autofocus]') || el.querySelector('button, a, input');
    setTimeout(() => f && f.focus({ preventScroll: true }), 60);
  }
  function closeOverlay(el) {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    if (!$('.is-open[data-overlay]')) document.documentElement.style.overflow = '';
    lastFocus && lastFocus.focus && lastFocus.focus({ preventScroll: true });
  }
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open]');
    if (opener) {
      const target = document.getElementById(opener.dataset.open);
      if (target) {
        if (opener.dataset.open === 'CartDrawer' && T.cartType !== 'drawer') return;
        e.preventDefault(); openOverlay(target);
      }
    }
    const closer = e.target.closest('[data-close]');
    if (closer) { e.preventDefault(); closeOverlay(closer.closest('[data-overlay]')); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') $$('.is-open[data-overlay]').forEach(closeOverlay);
  });

  /* ---------- Warenkorb ---------- */
  const Cart = {
    sectionIds() {
      const ids = new Set();
      $$('[data-cart-root]').forEach((el) => ids.add(el.dataset.cartRoot));
      return Array.from(ids);
    },
    render(sections) {
      if (!sections) return;
      Object.keys(sections).forEach((id) => {
        const html = sections[id];
        if (!html) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector(`[data-cart-root="${id}"]`);
        $$(`[data-cart-root="${id}"]`).forEach((el) => { if (fresh) el.innerHTML = fresh.innerHTML; });
      });
      const countEl = $('[data-cart-root] [data-item-count]');
      if (countEl) this.setCount(countEl.dataset.itemCount);
      document.dispatchEvent(new CustomEvent('cart:updated'));
    },
    setCount(n) {
      $$('[data-cart-count]').forEach((el) => { el.textContent = n > 0 ? n : ''; el.dataset.count = n; });
    },
    async add(formData, button) {
      button && button.classList.add('is-loading');
      const ids = this.sectionIds();
      if (ids.length) { formData.append('sections', ids.join(',')); formData.append('sections_url', window.location.pathname); }
      try {
        const res = await fetch(T.routes.cartAdd + '.js', { method: 'POST', body: formData, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } });
        const data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || data.message || T.strings.error);
        if (T.cartType !== 'drawer' && !$('[data-cart-root]')) { window.location.href = T.routes.cart; return; }
        this.render(data.sections);
        this.enforceLimits();
        const drawer = document.getElementById('CartDrawer');
        if (drawer && T.cartType === 'drawer') openOverlay(drawer); else toast(T.strings.added);
      } catch (err) {
        toast(err.message || T.strings.error);
      } finally {
        button && button.classList.remove('is-loading');
      }
    },
    async change(line, quantity, skipBundles) {
      const roots = $$('[data-cart-root]');
      roots.forEach((r) => r.classList.add('is-busy'));
      try {
        const res = await fetch(T.routes.cartChange + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line, quantity, sections: this.sectionIds(), sections_url: window.location.pathname })
        });
        const data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || data.message || T.strings.error);
        this.render(data.sections);
        await this.checkDependent(data);
        if (!skipBundles) await this.checkBundles(data);
      } catch (err) {
        toast(err.message || T.strings.error);
      } finally {
        roots.forEach((r) => r.classList.remove('is-busy'));
      }
    },
    async checkDependent(cart) {
      const d = T.dependent || {};
      if (!d.main || !d.child || !cart || !cart.items) return;
      const hasMain = cart.items.some((i) => i.product_id === d.main);
      const idx = cart.items.findIndex((i) => i.product_id === d.child);
      if (!hasMain && idx > -1) await this.change(idx + 1, 0);
    },
    packOf(title) {
      const t = String(title || '').toLowerCase().replace(/\s/g, '');
      const n = t.split('+').reduce((sum, part) => sum + (parseInt(part.split('x')[0], 10) || 0), 0);
      return n > 0 ? n : 1;
    },
    bundleAllowed(rule, count, sum) {
      if (rule.tiers) {
        if (sum < rule.min) return 0;
        return rule.tiers.reduce((a, t) => (sum >= t.value && t.qty > a ? t.qty : a), 0);
      }
      const metric = rule.type === 'sum' ? sum : count;
      if (metric < rule.threshold) return 0;
      if (rule.per > 0) return Math.min(rule.max, Math.floor(metric / rule.per));
      return rule.max;
    },
    parseRule(str) {
      const p = String(str || '').split(':');
      if (p[0] === 'tiers') {
        return { packs: true, min: parseFloat(p[2]) || 0, tiers: String(p[1] || '').split(',').map((x) => { const q = x.split('-'); return { value: parseFloat(q[0]) || 0, qty: parseInt(q[1], 10) || 0 }; }).filter((t) => t.value > 0) };
      }
      return { type: p[0] === 'sum' ? 'sum' : 'count', threshold: parseFloat(p[1]) || 0, per: parseFloat(p[2]) || 0, max: parseInt(p[3], 10) || 1, packs: p[4] !== '0' };
    },
    async checkBundles(cart, depth) {
      depth = depth || 0;
      if (this._bundleBusy || depth > 6) return;
      if (!cart || !cart.items) {
        try { cart = await (await fetch(T.routes.cart + '.js', { headers: { Accept: 'application/json' } })).json(); } catch (e) { return; }
      }
      const groups = {};
      cart.items.forEach((it, i) => {
        const pr = it.properties || {};
        if (pr._bundle_addon) {
          const g = groups[pr._bundle_addon] = groups[pr._bundle_addon] || { addons: [], rule: this.parseRule(pr._bundle_rule) };
          g.addons.push({ line: i + 1, qty: it.quantity });
        }
      });
      const keys = Object.keys(groups);
      if (!keys.length) return;
      for (const key of keys) {
        const g = groups[key];
        let count = 0, sum = 0;
        cart.items.forEach((it) => {
          if ((it.properties || {})._bundle !== key) return;
          count += it.quantity * (g.rule.packs ? this.packOf(it.variant_title) : 1);
          sum += it.original_line_price;
        });
        const allowed = this.bundleAllowed(g.rule, count, sum);
        const total = g.addons.reduce((a, x) => a + x.qty, 0);
        if (total > allowed) {
          const last = g.addons[g.addons.length - 1];
          const next = Math.max(0, last.qty - (total - allowed));
          this._bundleBusy = true;
          toast(T.strings.bundleRemoved || '');
          try { await this.change(last.line, next, true); } finally { this._bundleBusy = false; }
          return this.checkBundles(null, depth + 1);
        }
      }
    },
    async bundleLines(key) {
      const cart = await (await fetch(T.routes.cart + '.js', { headers: { Accept: 'application/json' } })).json();
      const updates = {};
      cart.items.forEach((it) => { const pr = it.properties || {}; if (pr._bundle === key || pr._bundle_addon === key) updates[it.key] = 0; });
      return updates;
    },
    async removeBundle(key, silent) {
      const roots = $$('[data-cart-root]');
      roots.forEach((r) => r.classList.add('is-busy'));
      try {
        const updates = await this.bundleLines(key);
        if (!Object.keys(updates).length) return;
        const res = await fetch(T.routes.cartUpdate + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates, sections: this.sectionIds(), sections_url: window.location.pathname })
        });
        const data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || data.message || T.strings.error);
        if (!silent) { this.render(data.sections); await this.checkDependent(data); }
      } catch (err) {
        toast(err.message || T.strings.error);
      } finally {
        roots.forEach((r) => r.classList.remove('is-busy'));
      }
    },
    async addItems(items, button, replaceKey) {
      button && button.classList.add('is-loading');
      try {
        if (replaceKey) await this.removeBundle(replaceKey, true);
        const res = await fetch(T.routes.cartAdd + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items, sections: this.sectionIds(), sections_url: window.location.pathname })
        });
        const data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || data.message || T.strings.error);
        if (!$('[data-cart-root]')) { window.location.href = T.routes.cart; return true; }
        this.render(data.sections);
        await this.enforceLimits();
        await this.checkBundles();
        const drawer = document.getElementById('CartDrawer');
        if (drawer && T.cartType === 'drawer') openOverlay(drawer); else toast(T.strings.added);
        return true;
      } catch (err) {
        toast(err.message || T.strings.error);
        return false;
      } finally {
        button && button.classList.remove('is-loading');
      }
    },
    async enforceLimits() {
      const over = $$('[data-cart-line][data-max]').find((i) => parseInt(i.value, 10) > parseInt(i.dataset.max, 10));
      if (!over || this._enforcing) return;
      this._enforcing = true;
      const max = parseInt(over.dataset.max, 10);
      toast((T.strings.maxQty || 'Maximal [count] Stück möglich.').replace('[count]', max));
      try { await this.change(parseInt(over.dataset.cartLine, 10), max); } finally { this._enforcing = false; }
    },
    updateNote: debounce((note) => {
      fetch(T.routes.cartUpdate + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note }) });
    }, 500)
  };
  window.BroatCart = Cart;
  window.BroatMoney = (cents, format) => money(cents, format || T.moneyFormat);

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[data-add-form]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type=submit]');
    if (btn && btn.disabled) return;
    Cart.add(new FormData(form), btn);
  });

  document.addEventListener('click', (e) => {
    const qtyBtn = e.target.closest('[data-qty-step]');
    if (qtyBtn) {
      const wrap = qtyBtn.closest('.qty');
      const input = wrap && wrap.querySelector('input');
      if (!input) return;
      const step = parseInt(qtyBtn.dataset.qtyStep, 10);
      const min = parseInt(input.min || '0', 10);
      const max = input.max ? parseInt(input.max, 10) : Infinity;
      const next = Math.min(max, Math.max(min, (parseInt(input.value, 10) || 0) + step));
      if (next === parseInt(input.value, 10)) return;
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    const payOpen = e.target.closest('[data-pay-open]');
    if (payOpen) {
      e.preventDefault();
      const dlg = document.getElementById('PayModal');
      if (dlg) { if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', ''); }
      return;
    }
    const payDlg = e.target.closest('#PayModal');
    if (payDlg && (e.target === payDlg || e.target.closest('[data-pay-close]'))) { if (payDlg.close) payDlg.close(); else payDlg.removeAttribute('open'); return; }
    const brm = e.target.closest('[data-bundle-remove]');
    if (brm) { e.preventDefault(); Cart.removeBundle(brm.dataset.bundleRemove); return; }
    const rm = e.target.closest('[data-cart-remove]');
    if (rm) { e.preventDefault(); Cart.change(parseInt(rm.dataset.cartRemove, 10), 0); }
  });

  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-cart-line]');
    if (input) {
      let q = Math.max(0, parseInt(input.value, 10) || 0);
      const cur = parseInt(input.dataset.qtyCurrent || '0', 10);
      const max = parseInt(input.dataset.max || '', 10);
      if (input.hasAttribute('data-qty-locked') && q > cur) { input.value = cur; return; }
      if (!isNaN(max) && q > max) {
        q = max; input.value = max;
        toast((T.strings.maxQty || 'Maximal [count] Stück möglich.').replace('[count]', max));
        if (q === cur) return;
      }
      Cart.change(parseInt(input.dataset.cartLine, 10), q);
    }
  });
  document.addEventListener('input', (e) => {
    const note = e.target.closest('[data-cart-note]');
    if (note) Cart.updateNote(note.value);
  });

  // Abhängige Artikel beim Seitenaufruf prüfen (Flag kommt aus Liquid)
  function initialDependentCheck() {
    if (!$('[data-dependent-orphan]')) return;
    fetch(T.routes.cart + '.js').then((r) => r.json()).then((c) => Cart.checkDependent(c));
  }

  /* ---------- Produktseite: Variantenauswahl ---------- */
  function money(cents, format) {
    const f = format || '{{amount_with_comma_separator}} €';
    const n = (cents / 100).toFixed(2);
    const [i, d] = n.split('.');
    const withDots = i.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return f.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withDots + ',' + d)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, withDots)
      .replace(/\{\{\s*amount\s*\}\}/, i.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + d)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, i);
  }

  function initProduct(root) {
    const dataEl = root.querySelector('[data-product-json]');
    if (!dataEl) return;
    const product = JSON.parse(dataEl.textContent);
    const form = root.querySelector('form[data-add-form]');
    const idInput = form && form.querySelector('input[name=id]');
    const picker = root.querySelector('[data-variant-picker]');
    const priceEl = root.querySelector('[data-price]');
    const unitEl = root.querySelector('[data-unit-note]');
    const btns = $$('[data-atc]', root).concat($$('[data-atc-sticky]'));
    const stickyPrice = $('[data-sticky-price]');
    const stickyVariant = $('[data-sticky-variant]');
    const moneyFormat = root.dataset.moneyFormat;

    function current() {
      if (!picker) return product.variants.find((v) => String(v.id) === idInput.value) || product.variants[0];
      const selected = $$('fieldset', picker).map((fs) => { const c = fs.querySelector('input:checked'); return c ? c.value : null; });
      return product.variants.find((v) => v.options.every((o, i) => o === selected[i]));
    }

    function update() {
      const v = current();
      btns.forEach((b) => {
        const label = b.querySelector('[data-atc-label]') || b;
        if (!v) { b.disabled = true; label.textContent = T.strings.unavailable; return; }
        b.disabled = !v.available;
        label.textContent = v.available ? T.strings.addToCart : T.strings.soldOut;
      });
      if (!v) return;
      idInput.value = v.id;
      const tpl = root.querySelector(`template[data-price-for="${v.id}"]`);
      if (priceEl && tpl) priceEl.innerHTML = tpl.innerHTML;
      const utpl = root.querySelector(`template[data-unit-for="${v.id}"]`);
      if (unitEl) unitEl.innerHTML = utpl ? utpl.innerHTML : '';
      const itpl = root.querySelector(`template[data-info-for="${v.id}"]`);
      const ibody = root.querySelector('[data-variant-info-body]');
      if (ibody && itpl) ibody.innerHTML = itpl.innerHTML;
      if (stickyPrice) stickyPrice.textContent = money(v.price, moneyFormat);
      $$('[data-atc-price]', root).forEach((el) => { el.textContent = money(v.price, moneyFormat); });
      if (stickyVariant) stickyVariant.textContent = v.title === 'Default Title' ? '' : v.title;
      if (v.featured_media) {
        const slide = root.querySelector(`[data-media-id="${v.featured_media.id}"]`);
        slide && scrollGalleryTo(root, slide);
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
      // Verfügbarkeit je Option markieren
      if (picker) {
        $$('fieldset', picker).forEach((fs, idx) => {
          $$('input', fs).forEach((inp) => {
            const opts = (v.options || []).slice(); opts[idx] = inp.value;
            const match = product.variants.find((x) => x.options.every((o, i) => o === opts[i]));
            inp.classList.toggle('is-unavailable', !match || !match.available);
          });
        });
      }
    }
    picker && picker.addEventListener('change', update);
    initGallery(root);
    initSticky(root);
  }

  /* ---------- Galerie ---------- */
  function scrollGalleryTo(root, slide) {
    const track = root.querySelector('[data-gallery-track]');
    if (track && slide) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
  }
  function initGallery(root) {
    const track = root.querySelector('[data-gallery-track]');
    if (!track) return;
    const slides = $$('[data-media-id]', track);
    const thumbs = $$('[data-thumb]', root);
    const dots = $$('[data-dot]', root);
    thumbs.forEach((t, i) => t.addEventListener('click', () => scrollGalleryTo(root, slides[i])));
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (en.isIntersecting && en.intersectionRatio > 0.6) {
          const i = slides.indexOf(en.target);
          thumbs.forEach((t, j) => t.setAttribute('aria-current', i === j));
          const at = thumbs[i];
          if (at && at.parentNode.scrollWidth > at.parentNode.clientWidth) {
            const strip = at.parentNode;
            strip.scrollTo({ left: at.offsetLeft - strip.offsetLeft - (strip.clientWidth - at.offsetWidth) / 2, behavior: 'smooth' });
          }
          dots.forEach((d, j) => d.classList.toggle('is-active', i === j));
        }
      });
    }, { root: track, threshold: [0.6] });
    slides.forEach((s) => io.observe(s));
  }

  /* ---------- Sticky Add-to-Cart (mobil) ---------- */
  function initSticky(root) {
    const bar = $('[data-sticky-atc]');
    const anchor = root.querySelector('[data-atc]');
    if (!bar || !anchor) return;
    const io = new IntersectionObserver(([en]) => {
      const past = !en.isIntersecting && en.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', past);
    });
    io.observe(anchor);
    bar.addEventListener('click', (e) => {
      if (e.target.closest('[data-atc-sticky]')) {
        e.preventDefault();
        const form = root.querySelector('form[data-add-form]');
        form && form.requestSubmit();
      }
    });
  }

  /* ---------- Ankündigungsleiste (Laufband) ----------
     Text steht einmal im HTML; für die Endlosschleife wird die Gruppe
     per JS geklont und für Screenreader ausgeblendet. */
  function initAnnouncement() {
    $$('[data-announcement]').forEach((bar) => {
      if (bar.dataset.mode === 'static' || bar.dataset.ready) return;
      const track = bar.querySelector('.announcement__track');
      const group = track && track.querySelector('.announcement__group');
      if (!group) return;
      let copies = 1;
      while (track.scrollWidth < window.innerWidth * 2 && copies < 8) {
        const c = group.cloneNode(true); c.setAttribute('aria-hidden', 'true');
        c.querySelectorAll('a').forEach((a) => a.setAttribute('tabindex', '-1'));
        track.appendChild(c); copies++;
      }
      if (copies % 2) { const c = group.cloneNode(true); c.setAttribute('aria-hidden', 'true'); track.appendChild(c); }
      bar.dataset.ready = '1';
    });
  }

  /* ---------- Suchvorschläge ---------- */
  function initPredictive() {
    const input = $('[data-predictive-input]');
    const out = $('[data-predictive-results]');
    if (!input || !out) return;
    let ctrl;
    input.addEventListener('input', debounce(async () => {
      const q = input.value.trim();
      if (q.length < 2) { out.innerHTML = ''; return; }
      ctrl && ctrl.abort(); ctrl = new AbortController();
      try {
        const r = await fetch(`${T.routes.predictiveSearch}?q=${encodeURIComponent(q)}&section_id=predictive-search&resources[type]=product,article,page&resources[limit]=6`, { signal: ctrl.signal });
        const html = await r.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const res = doc.querySelector('[data-predictive-inner]');
        out.innerHTML = res ? res.innerHTML : '';
      } catch (_) { /* abgebrochen */ }
    }, 250));
  }

  /* ---------- Slider-Pfeile ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-slide]');
    if (!b) return;
    const track = document.getElementById(b.dataset.target);
    if (!track) return;
    const w = track.firstElementChild ? track.firstElementChild.getBoundingClientRect().width + 24 : 300;
    track.scrollBy({ left: b.dataset.slide === 'next' ? w : -w, behavior: 'smooth' });
  });

  /* ---------- Einblenden ---------- */
  function initReveal() {
    if (!document.documentElement.classList.contains('has-anim') || !('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver((entries) => entries.forEach((en) => {
      if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
    }), { rootMargin: '0px 0px -8% 0px' });
    $$('.reveal').forEach((el) => io.observe(el));
  }

  /* ---------- Inhaltsverzeichnis in Artikeln ---------- */
  function initToc() {
    const toc = $('[data-toc]');
    const body = $('[data-article-body]');
    if (!toc || !body) return;
    const hs = $$('h2', body);
    if (hs.length < 3) { toc.remove(); return; }
    const ol = toc.querySelector('ol');
    hs.forEach((h, i) => {
      if (!h.id) h.id = 'abschnitt-' + (i + 1) + '-' + h.textContent.trim().toLowerCase().replace(/[^a-z0-9äöüß]+/g, '-').replace(/^-|-$/g, '').slice(0, 50);
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.href = '#' + h.id; a.textContent = h.textContent.trim();
      li.appendChild(a); ol.appendChild(li);
    });
    toc.hidden = false;
  }

  /* ---------- Kollektion ---------- */
  function initCollection() {
    $$('[data-sort]').forEach((sel) => sel.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      window.location.href = url.toString();
    }));
    $$('[data-readmore]').forEach((btn) => {
      const target = document.getElementById(btn.dataset.readmore);
      if (!target) return;
      if (target.scrollHeight <= target.clientHeight + 4) { btn.hidden = true; return; }
      btn.addEventListener('click', () => { target.classList.remove('is-clamped'); btn.hidden = true; });
    });
  }

  /* ---------- Header beim Scrollen ---------- */
  function initHeader() {
    const header = $('[data-header]');
    if (!header) return;
    window.addEventListener('scroll', () => header.classList.toggle('is-scrolled', window.scrollY > 10), { passive: true });
    if (header.dataset.sticky !== 'smart') return;
    let last = 0;
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      header.style.transform = (y > last && y > 200) ? 'translateY(-100%)' : '';
      last = y;
    }, { passive: true });
  }

  /* ---------- Produktempfehlungen (Shopify Recommendations API) ---------- */
  function initRecommendations(scope = document) {
    $$('[data-recommendations]', scope).forEach(async (el) => {
      if (el.querySelector('[data-recommendations-inner]')) return;
      try {
        const r = await fetch(el.dataset.recommendations);
        const html = await r.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const inner = doc.querySelector('[data-recommendations-inner]');
        if (inner) el.appendChild(inner); else el.remove();
      } catch (_) { el.remove(); }
    });
  }

  function init() {
    initRecommendations();
    $$('[data-product]').forEach(initProduct);
    initAnnouncement();
    initPredictive();
    initReveal();
    initToc();
    initCollection();
    initHeader();
    initialDependentCheck();
    if ($('[data-bundle-check]')) Cart.checkBundles();
    Cart.enforceLimits();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  // Theme-Editor: Sections nach dem Neuladen initialisieren
  document.addEventListener('shopify:section:load', (e) => {
    $$('[data-product]', e.target).forEach(initProduct);
    initAnnouncement(); initReveal(); initCollection(); initRecommendations(e.target);
  });
  document.addEventListener('shopify:section:select', (e) => {
    if (e.target.querySelector('#CartDrawer')) openOverlay(document.getElementById('CartDrawer'));
  });
  document.addEventListener('shopify:section:deselect', (e) => {
    if (e.target.querySelector('#CartDrawer')) closeOverlay(document.getElementById('CartDrawer'));
  });
})();
